import { combineReducers, configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Choose your storage engine
import userReducer from './reducers/user'
import rootSaga from './sagas';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import tableReducer from './reducers/table';
import componentReducer from './reducers/component';
import itemReducer from './reducers/item';
import uiReducer from './reducers/ui';
import componentsReducer from './reducers/components';

const sagaMiddleware = createSagaMiddleware()
const rootReducer: any = combineReducers({
    user: userReducer,
    table: tableReducer,
    component: componentReducer,
    item: itemReducer,
    ui: uiReducer,
    components: componentsReducer,
});
const persistConfig: any = {
    key: 'root',
    storage: storage,
    stateReconciler: hardSet
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});
sagaMiddleware.run(rootSaga)
export default store
export const persistor = persistStore(store)
